export enum StatusSessaoMesa {
    ABERTA = "aberta",
    CONTA_SOLICITADA = "conta_solicitada",
    ENCERRADA = "encerrada",
}

/** Sessão compartilhada por quem leu o QR Code de uma mesa. */
export interface ISessaoMesa {
    uuid: string;
    mesaId: number;
    pedidoUuid: string;
    marketplaceUuid: string;
    status: StatusSessaoMesa;
    participantes: { uuid: string; nome: string }[];
    abertaAs: string;
    contaSolicitadaAs?: string;
    contaSolicitadaPor?: string;
    encerradaAs?: string;
}

export interface IQRCodeMesa {
    mesaId: number;
    token: string;
}
